import { axiosInstance } from "./config";

export default {
  state: {
    translation: {},
  },
  mutations: {
    Set_translation(state, payload) {
      state.translation = payload;
    },
  },
  actions: {
    async Get_all_translation({ commit }) {
      return await axiosInstance
        .get(`/translation`)
        .then(function (data) {
          commit("Set_translation", data?.data?.data);
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Get_byID_translation({}, payload) {
      return await axiosInstance
        .get(`/translation/id/${payload.id ?? payload}`)
        .then(function (data) {
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Get_byKey_translation({}, payload) {
      return await axiosInstance
        .get(`/translation/${payload.key ?? payload}`)
        .then(function (data) {
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Post_translation({}, payload) {
      return await axiosInstance
        .post("/translation/", payload)
        .then(function (data) {
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Put_byID_translation({}, payload) {
      return await axiosInstance
        .put("/translation/id/" + payload.id, payload)
        .then(function (data) {
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Put_byKey_translation({}, payload) {
      return await axiosInstance
        .put("/translation/" + payload.key, payload)
        .then(function (data) {
          return data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Delete_byID_translation({}, payload) {
      return await axiosInstance
        .put("/translation/id/" + payload.id ?? payload)
        .then(function (data) {
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Delete_byKey_translation({}, payload) {
      return await axiosInstance
        .put("/translation/" + payload.key ?? payload)
        .then(function (data) {
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
  },
  getters: {
    g_translation: (state) => state.translation,
  },
};
